<template>
  <div class="c-app">
    <SidebarDocument :key="locale" />
    <CWrapper>
      <Header />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view />
            </transition>
          </CContainer>
        </main>
        <Footer />
        <UserLoading v-if="loading" />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import SidebarDocument from "../commons/SidebarDocument";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import UserLoading from "../commons/Loading";
import { mapState } from "vuex";

export default {
  name: "DocumentLayout",
  metaInfo() {
    return {
      title: "",
      titleTemplate: "株式会社 Fabbi"
    };
  },
  components: {
    SidebarDocument,
    Header,
    Footer,
    UserLoading
  },

  computed: {
    ...mapState("layout", {
      loading: state => state.loading
    }),
    locale: function() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style lang="scss" scoped></style>
